/**
 * Given cities and a location, this function will extract the country code.
 */
export const getCityCountryCode = city => city.country || city.countryCode || 'Any';
